import { render } from "./EditAddBescStep3.vue?vue&type=template&id=0cc33dc6&ts=true"
import script from "./EditAddBescStep3.vue?vue&type=script&lang=ts"
export * from "./EditAddBescStep3.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__